import { useThemeMode } from '../context/ThemeProvider';
import styled from 'styled-components';

const Toggle = styled.button`
  border: none;
  background: ${({ theme }) => theme.colors.gray100};
  color: ${({ theme }) => theme.colors.gray700};
  padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(2)};
  border-radius: ${({ theme }) => theme.radius};
  cursor: default;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);

  &:disabled {
    opacity: 0.8;
  }
`;

export default function ThemeToggle() {
  const { toggle } = useThemeMode();

  return (
    <Toggle onClick={toggle} title="Theme switching is temporarily disabled" disabled>
      Dark mode enabled
    </Toggle>
  );
}
